<template>
  <div>
    <OilDataCap
      :title='capTitle'
      :buttons='capButtons'
    />
    <v-divider class='my-2' />

    <OilDataTable
      :keys='tableKey'
      :items='importer_consignments'
      :paginate='count'
      @paginateAction='paginate'
    >
      <template v-slot:Id='{value}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn v-bind='attrs'
                   v-on='on' icon
                   @click.stop='handleRowClick(value)'>
              <v-icon color='primary'>
                mdi-pen
              </v-icon>
            </v-btn>
          </template>
          <span>РЕДАКТИ́РОВАТЬ</span>
        </v-tooltip>
      </template>
    </OilDataTable>
  </div>
</template>

<script>

import { cap, table } from './setting/consignments.json'
import { consignmentImporterService } from '~/services/ConsignmentImporterService'
import { coreApi } from '~/services/core'

export default {
  components: {
    OilDataTable: () => import('@/components/helper/oil.table'),
    OilDataCap: () => import('@/components/helper/oil.cap')
  },
  data() {
    return {
      capTitle: cap.title,
      capButtons: cap.buttons,
      tableKey: table.keys,
      importer_consignments: [],
      count:{
        count:0
      }
    }
  },
  async created() {
    await this.paginate((this.currentPage - 1) * 10)
    // const importersConsignment = await consignmentImporterService.getAll()
    // this.importer_consignments = importersConsignment.data?.map(importerConsignment => {
    //   return {
    //     ImporterName: importerConsignment.Importer?.Name,
    //     GtdNumber: importerConsignment.GosDeclaration?.Number,
    //     ProductName: importerConsignment.Product?.Name,
    //     TotalAmount: importerConsignment.PartyInformation?.TotalAmountInTons,
    //     Sum:this.regular(importerConsignment?.Amount),
    //     Sebest:this.regular(importerConsignment?.PricePerTonInSoums),
    //     Id: importerConsignment.Id,
    //   }
    // })

  },
  methods: {
    handleRowClick(Id) {
      this.$router.push(`/importers-consignment/${Id}`)
    },

    async paginate(page) {
      const importer_consignments =await consignmentImporterService.paginate(page)
      const { count, dates } = importer_consignments.data
      this.count.count = count
      this.importer_consignments = dates?.map(importerConsignment => {
        return {
          ImporterName: importerConsignment.Importer?.Name,
          GtdNumber: importerConsignment.GosDeclaration?.Number,
          ProductName: importerConsignment.Product?.Name,
          TotalAmount: importerConsignment.PartyInformation?.TotalAmountInTons,
          Sum:this.regular(importerConsignment?.Amount),
          Sebest:this.regular(importerConsignment?.PricePerTonInSoums),
          Id: importerConsignment.Id,
        }
      })
    },

  }



}
</script>

<style scoped>

</style>